import PropTypes from "prop-types";
import React, { useContext, useState } from "react";
import { updateWpUser } from "../../../api/wordpress";
import { UserContext } from "../../../contexts/user.context";
import { calculateAge } from "../../../utils/functions";
import OccupationDropdown from "../../dropdowns/occupation";
import InputField from "../../fields/input-field/form-input.component";

const defaultFormFields = {
  next_of_kin: "",
  date_of_birth: "",
  address: "",
  work_place: "",
  occupation_status: "",
};

const defaultErrorObject = {
  code: "",
  status: false,
  message: "",
};

export default function BiodataRegister({ onCompleted }) {
  const [formFields, setFormFields] = useState(defaultFormFields);
  const { next_of_kin, date_of_birth, address, work_place, occupation_status } =
    formFields;

  const [loading, setLoading] = useState(false);
  // const [successModalState, setSuccessModalState] = useState(false);
  const [errorObj, setLoginError] = useState(defaultErrorObject);

  const { accessToken, persistUpdatedUser } = useContext(UserContext);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormFields({ ...formFields, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (calculateAge(new Date(formFields.date_of_birth)) < 18) {
      setLoginError({
        code: 500,
        message:
          "Uh oh! You must be at least 18 years old to register for this service",
        status: true,
      });
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("next_of_kin", formFields.next_of_kin);
      formData.append("address", formFields.address);
      formData.append("work_place", formFields.work_place);
      formData.append("occupation_status", formFields.occupation_status);
      formData.append("date_of_birth", formFields.date_of_birth);
      const response = await updateWpUser(accessToken, formData);
      persistUpdatedUser(response.data);
      onCompleted();
      //setSuccessModalState(true);
    } catch (error) {
      setLoading(false);
      const { code, message } = error.response ? error.response.data : error;

      setLoginError({
        code: code,
        message: message,
        status: true,
      });
    }
  };
  return (
    <>
      <h2 className="text-3xl mt-10 mb-8 header-font font-semibold text-center">
        Complete Registration
      </h2>
      <form
        id="register_form"
        className="font-light"
        type="post"
        onSubmit={handleSubmit}
      >
        {errorObj.status && (
          <div
            className="flex p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
            role="alert"
          >
            <svg
              className="inline flex-shrink-0 mr-3 w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              ></path>
            </svg>
            <div dangerouslySetInnerHTML={{ __html: errorObj.message }} />
          </div>
        )}

        <OccupationDropdown
          selected={occupation_status}
          onSelected={(value) =>
            setFormFields({ ...formFields, occupation_status: value })
          }
        />
        <InputField
          label="Work place"
          type="text"
          name="work_place"
          value={work_place}
          required
          onChange={handleChange}
        />
        <InputField
          label="Address"
          type="text"
          name="address"
          value={address}
          required
          onChange={handleChange}
        />
        <InputField
          label="Date of birth"
          type="date"
          name="date_of_birth"
          value={date_of_birth}
          required
          onChange={handleChange}
        />
          <InputField
            label="Next of kin"
            type="text"
            name="next_of_kin"
            value={next_of_kin}
            required
            onChange={handleChange}
          />
        <div className="field_wrapper mb-5">
          <button
            type="submit"
            className="w-full rounded-md text-white p-3 bg-primary hover:bg-blue-900 font-semibold cursor-pointer"
          >
            {loading ? (
              <svg
                role="status"
                className="inline w-6 h-6 mr-3 text-white animate-spin border-2 rounded-full border-gray-500"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
            ) : (
              "Complete Registration"
            )}
          </button>
        </div>
      </form>
    </>
  );
}

BiodataRegister.propTypes = {
  onCompleted: PropTypes.func.isRequired,
};
